var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NO_DATA",class:_vm.className,style:({
    zIndex: _vm.zIndex,
  })},[_c('div',{staticClass:"nodata_logo"}),_c('span',{staticClass:"nodata_info mixtmt_font_12px",domProps:{"textContent":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }